import React from 'react';
import { connect } from 'react-redux';
import { firstError, firstErrorMessage, hasErrorCode } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import errorCodes from '@/constants/errors';
import Error from '@/components/errors/Error';
import NotAuthorised from '@/components/errors/NotAuthorised';
import SearchResultCards from './SearchResultCards';

const SearchResults = ({
  canRun,
  category,
  code,
  compact,
  searchErrors,
}) => {
  if (!canRun || hasErrorCode(searchErrors, errorCodes.forbidden)) {
    return (<NotAuthorised />);
  }

  if (firstError(searchErrors)) {
    return <Error error={firstErrorMessage(searchErrors)} className="aridhia-search-error" />;
  }

  return (<SearchResultCards code={code} category={category} compact={compact} />);
};

const mapStateToProps = ({
  auth: { role: { permissions: { search: { run } } } },
  search: { searches },
}, { category, code }) => {
  const item = findResult(searches, category, code);

  return (
    {
      searchErrors: item ? item.searchErrors : [],
      canRun: run,
    }
  );
};

export default connect(mapStateToProps)(SearchResults);
